import { Ban } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface BlockedStatusBadgeProps {
  /** The reason the location was blocked */
  reason?: string | null;
}

/**
 * Shows "Blocked" badge for locations that have been blocked from publishing.
 * Displays the block reason in a tooltip on hover.
 */
export function BlockedStatusBadge({ reason }: BlockedStatusBadgeProps): JSX.Element {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="destructive"
            className="cursor-help gap-1"
            data-testid="blocked-badge"
          >
            <Ban className="h-3 w-3" />
            Blocked
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="font-medium mb-1">This location is blocked</p>
          {reason && (
            <p className="text-xs text-muted-foreground">{reason}</p>
          )}
          {!reason && (
            <p className="text-xs text-muted-foreground">No reason provided</p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
